import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-message-square-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        fill="currentColor"
        d="M9.99984 19.0087C9.42484 19.0087 8.88317 18.717 8.49984 18.2087L7.24984 16.542C7.22484 16.5087 7.12484 16.467 7.08317 16.4587H6.6665C3.1915 16.4587 1.0415 15.517 1.0415 10.8337V6.66699C1.0415 2.98366 2.98317 1.04199 6.6665 1.04199H13.3332C17.0165 1.04199 18.9582 2.98366 18.9582 6.66699V10.8337C18.9582 14.517 17.0165 16.4587 13.3332 16.4587H12.9165C12.8498 16.4587 12.7915 16.492 12.7498 16.542L11.4998 18.2087C11.1165 18.717 10.5748 19.0087 9.99984 19.0087ZM6.6665 2.29199C3.68317 2.29199 2.2915 3.68366 2.2915 6.66699V10.8337C2.2915 14.6003 3.58317 15.2087 6.6665 15.2087H7.08317C7.50817 15.2087 7.9915 15.4503 8.24984 15.792L9.49984 17.4587C9.7915 17.842 10.2082 17.842 10.4998 17.4587L11.7498 15.792C12.0248 15.4253 12.4582 15.2087 12.9165 15.2087H13.3332C16.3165 15.2087 17.7082 13.817 17.7082 10.8337V6.66699C17.7082 3.68366 16.3165 2.29199 13.3332 2.29199H6.6665Z" />
      <path
        fill="currentColor"
        d="M9.99984 9.99967C9.53317 9.99967 9.1665 9.62467 9.1665 9.16634C9.1665 8.70801 9.5415 8.33301 9.99984 8.33301C10.4582 8.33301 10.8332 8.70801 10.8332 9.16634C10.8332 9.62467 10.4665 9.99967 9.99984 9.99967Z" />
      <path
        fill="currentColor"
        d="M13.3333 9.99967C12.8667 9.99967 12.5 9.62467 12.5 9.16634C12.5 8.70801 12.875 8.33301 13.3333 8.33301C13.7917 8.33301 14.1667 8.70801 14.1667 9.16634C14.1667 9.62467 13.8 9.99967 13.3333 9.99967Z" />
      <path
        fill="currentColor"
        d="M6.66683 9.99967C6.20016 9.99967 5.8335 9.62467 5.8335 9.16634C5.8335 8.70801 6.2085 8.33301 6.66683 8.33301C7.12516 8.33301 7.50016 8.70801 7.50016 9.16634C7.50016 9.62467 7.1335 9.99967 6.66683 9.99967Z" />
    </svg>
  `,
})
export class MessageSquareIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 20 20');
}
